import React, { useEffect, useState } from "react"
import { Alert, Col, Label, Modal, Row } from "reactstrap"
import api from "services/api.service"
import { CostPoolEditableCell, getColorsByTableName } from "../ForecastSection"
import { currencyFormatter } from "utils/formatters"
import { TextareaAutosize } from "@material-ui/core"
import Loader from "react-loaders"
import colors from "utils/colors"
import isNullOrEmpty from "utils/isNullOrEmpty"
import { toast } from "react-toastify"
import { userService } from "services/user.service"
import CurrencyInput from "react-currency-input-field"
import { set } from "lodash"

const FinancingModal = ({
  isOpen,
  toggleModal,
  alternativeId,
  enterpriseId,
  reload,
}) => {
  const currentUser = userService.getLoggedInUser()
  const [isLoading, setIsLoading] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [costTable1, setCostTable1] = useState([])
  const [costTable2, setCostTable2] = useState([])
  const [costTable3, setCostTable3] = useState([])
  //[{ yearID}]
  const [costPoolYears, setCostPoolYears] = useState([])
  const [interestRates, setInterestRates] = useState([])
  const [feeRates, setFeeRates] = useState([])
  const [interestAndFeeRates, setInterestAndFeeRates] = useState([])
  const [selectedRateId, setSelectedRateId] = useState(-1)
  const [isEditMode, setIsEditMode] = useState(true)
  const [summaryTable, setSummaryTable] = useState([])

  const [selectedCostPoolId, setSelectedCostPoolId] = useState(-1)
  const [allCosts, setAllCosts] = useState([])

  useEffect(() => {
    if (isOpen) {
      setIsEditMode(true)
      loadData(true)
    }
  }, [isOpen])

  useEffect(() => {
    if (selectedRateId != -1 && !isEditMode) {
      viewRate(selectedRateId)
    }
  }, [selectedRateId, isEditMode])

  const loadData = async toggleLoading => {
    if (toggleLoading === undefined || toggleLoading === true)
      setIsLoading(true)

    let costs = await api.getBCCostPools(alternativeId, "cost", false, false)
    let costWithYears = costs.find(
      x => x.bcCostPoolYears !== null && x.bcCostPoolYears.length > 0
    )
    let cpYears = costWithYears.bcCostPoolYears.map(y => {
      return { yearID: y.yearID }
    })
    if (costWithYears !== undefined) {
      setCostPoolYears(cpYears)
    }

    await loadInterestRates()

    let ct1Costs = costs.filter(x => x.costPoolTypeID == 10)
    let ct2Costs = costs.filter(x => x.costPoolTypeID == 20)
    let ct3Costs = costs.filter(x => x.costPoolTypeID == 30)

    let ct1 = []
    let ct2 = []
    let ct3 = []
    if (ct1Costs.find(x => hasNon0Amounts(x, cpYears)) != undefined) {
      ct1 = [
        ct1Costs[0],
        ...ct1Costs.filter(
          x => x.bcCostPoolID > 0 && hasNon0Amounts(x, cpYears)
        ),
      ]
    }
    if (ct2Costs.find(x => hasNon0Amounts(x, cpYears)) != undefined) {
      ct2 = [
        ct2Costs[0],
        ...ct2Costs.filter(
          x => x.bcCostPoolID > 0 && hasNon0Amounts(x, cpYears)
        ),
      ]
    }
    if (ct3Costs.find(x => hasNon0Amounts(x, cpYears)) != undefined) {
      ct3 = [
        ct3Costs[0],
        ...ct3Costs.filter(
          x => x.bcCostPoolID > 0 && hasNon0Amounts(x, cpYears)
        ),
      ]
    }

    setCostTable1(ct1)
    setCostTable2(ct2)
    setCostTable3(ct3)
    setAllCosts(costs.filter(x => x.bcCostPoolID > 0))

    setIsLoading(false)
  }

  const hasNon0Amounts = (cost, cpYears) => {
    let ret = false
    cpYears.forEach(y => {
      if (cost.bcCostPoolYears.find(x => x.yearID == y.yearID)?.amount > 0) {
        ret = true
      }
    })

    return ret
  }

  const saveData = async () => {
    setIsSaving(true)
    let rowsToUpdate = []
    rowsToUpdate = rowsToUpdate.concat(costTable1.filter(x => x.isDirty))
    rowsToUpdate = rowsToUpdate.concat(costTable2.filter(x => x.isDirty))
    rowsToUpdate = rowsToUpdate.concat(costTable3.filter(x => x.isDirty))

    if (rowsToUpdate.length > 0) {
      let rowsToUpdateTasks = rowsToUpdate.map(x => async () => {
        return await api.updateBCCostPool(currentUser.userID, x)
      })
      await Promise.all(rowsToUpdateTasks.map(t => t()))
      await api.updateAlternativeMetrics(alternativeId)
      // reload && reload()
      toast.success(`Finance updated successfully`)
    }
    setIsSaving(false)
    await loadData(true)
  }

  const loadInterestRates = async () => {
    let bcRates = await api.getEnterpriseBcRates(enterpriseId)
    let feeRates = bcRates.filter(x => x.rateType == "Fee")
    let intRates = bcRates.filter(x => x.rateType == "Interest")

    // let tasks = intRates.map(x => async () => {
    //   return await api.getFinancingSummary(alternativeId, x.bcRateID)
    // })

    // if (tasks.length > 0) {
    //   let responses = await Promise.all(tasks.map(t => t()))
    //   responses.forEach((r, idx) => {
    //     intRates[idx].interestRatesTable = r
    //   })
    // }

    // let feeTasks = feeRates.map(x => async () => {
    //   return await api.getFinancingSummary(alternativeId, x.bcRateID)
    // })

    // if (feeTasks.length > 0) {
    //   let responses = await Promise.all(feeTasks.map(t => t()))
    //   responses.forEach((r, idx) => {
    //     feeRates[idx].feeRatesTable = r
    //   })
    // }

    setInterestRates(intRates)
    setFeeRates(feeRates)

    setInterestAndFeeRates([...intRates, ...feeRates])
  }

  const changeProp = (tableNameToModify, yearID, value, bcCostPoolId) => {
    let list = [...getListByTableName(tableNameToModify)]
    let setter = getSetterByTableName(tableNameToModify)
    let itemToModify = list.find(x => x.bcCostPoolID == bcCostPoolId)
    let yearToModify = itemToModify.bcCostPoolYears.find(
      x => x.yearID == yearID
    )
    if (yearToModify !== undefined) yearToModify.percFinance = value
    itemToModify.isDirty = true

    setter(list)
  }

  const changeCostPoolProp = (
    tableNameToModify,
    propToModify,
    value,
    bcCostPoolId
  ) => {
    let list = [...getListByTableName(tableNameToModify)]
    let setter = getSetterByTableName(tableNameToModify)
    let itemToModify = list.find(x => x.bcCostPoolID == bcCostPoolId)
    itemToModify[propToModify] = value
    itemToModify.isDirty = true

    setter(list)
  }

  const changeCostPoolProps = (
    tableNameToModify,
    yearsToModify,
    values,
    bcCostPoolId
  ) => {
    let list = [...getListByTableName(tableNameToModify)]
    let setter = getSetterByTableName(tableNameToModify)
    let itemToModify = list.find(x => x.bcCostPoolID == bcCostPoolId)

    for (let i = 0; i < yearsToModify.length; i++) {
      let year = itemToModify.bcCostPoolYears.find(
        x => x.yearID == yearsToModify[i]
      )
      if (year !== undefined) year.percFinance = values[i]
    }

    itemToModify.isDirty = true

    setter(list)
  }

  const getSetterByTableName = tableName => {
    if (tableName == "costTable1") {
      return setCostTable1
    }
    if (tableName == "costTable2") {
      return setCostTable2
    }
    if (tableName == "costTable3") {
      return setCostTable3
    }
  }

  const getListByTableName = tableName => {
    if (tableName == "costTable1") {
      return costTable1
    }
    if (tableName == "costTable2") {
      return costTable2
    }
    if (tableName == "costTable3") {
      return costTable3
    }
  }

  const getTableRowsToRender = (list, listName) => {
    return (
      <React.Fragment>
        {list.length > 0 &&
          list.map((c, i) => {
            if (i == 0 || c.bcCostPoolID > 0)
              return (
                <tr
                  key={i}
                  style={{
                    backgroundColor:
                      i == 0
                        ? getColorsByTableName(listName).backgroundColor
                        : "inherit",
                    color:
                      i == 0 ? getColorsByTableName(listName).color : "inherit",
                  }}
                >
                  <td
                    style={{
                      verticalAlign: "middle",
                      fontWeight: i == 0 ? 600 : "inherit",
                      backgroundColor:
                        getColorsByTableName(listName).backgroundColor,
                      color: getColorsByTableName(listName).color,
                    }}
                  >
                    {c.costPoolName}
                  </td>
                  <td>
                    {i !== 0 && (
                      <CurrencyInput
                        className="form-control align-end"
                        style={{
                          padding: "1px",
                          fontSize: "12px",
                          fontWeight: "normal",
                        }}
                        value={c.all}
                        onValueChange={(value, name, values) => {
                          changeCostPoolProps(
                            listName,
                            ["all", ...costPoolYears.map(y => y.yearID)],
                            [value, ...costPoolYears.map(y => value)],
                            c.bcCostPoolID
                          )
                        }}
                        suffix={"%"}
                      />
                    )}
                  </td>
                  {costPoolYears.length > 0 &&
                    costPoolYears.map((y, idx) => (
                      <td key={idx}>
                        {i !== 0 && (
                          <CostPoolEditableCell
                            costPool={c}
                            costPoolYear={y}
                            changeProp={changeProp}
                            listName={listName}
                            propName="percFinance"
                            suffix="%"
                            key={idx}
                            isBoldFunc={e => e > 0}
                          />
                        )}
                      </td>
                    ))}
                </tr>
              )
          })}
      </React.Fragment>
    )
  }

  const getYearTotals = (table, year) => {
    return table.reduce((acc, item) => {
      const existingYear = item.bcCostPoolYears.find(
        x => x.yearID == year.yearID
      )
      return acc + (existingYear !== undefined ? existingYear.percFinance : 0)
    }, 0)
  }

  const getTotals = (table, propToSum) => {
    return table.reduce((acc, item) => {
      return acc + item[propToSum]
    }, 0)
  }

  const getRowTotals = (row, prop) => {
    return row.bcCostPoolYears.reduce((acc, item) => {
      return acc + item[prop]
    }, 0)
  }

  const getTableYearsTotals = (table, prop) => {
    let total = 0
    table.forEach(item => {
      item.bcCostPoolYears.forEach(y => {
        total += y.percFinance
      })
    })

    return total
  }

  const viewRate = async () => {
    setIsLoading(true)
    // setIsEditMode(!isEditMode)
    let summary = await api.getFinancingSummary(alternativeId, selectedRateId)
    setSummaryTable(summary)
    setIsLoading(false)
  }

  const copyToCostPool = async () => {
    let cp = allCosts.find(
      x => x.costPoolID == selectedCostPoolId
    )

    if (cp != undefined) {
      let totalCostSummaryRow = summaryTable.find(
        x => x["c-Cost Pool"] == "Total Cost"
      )
      if (totalCostSummaryRow != undefined) {
        costPoolYears.forEach((y, idx) => {
          let exists = cp.bcCostPoolYears.find(x => x.yearID == y.yearID)
          if (exists != undefined) {
            exists.amount = totalCostSummaryRow[`c-${y.yearID}`]
          } else {
            cp.bcCostPoolYears.push({
              yearID: y.yearID,
              amount: totalCostSummaryRow[`c-${y.yearID}`],
              bcCostPoolID: cp.bcCostPoolID,
            })
          }
        })

        await api.updateBCCostPool(currentUser.userID, cp)
        toast.success("Values copied successfuly")
      }
    }
  }

  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      size="xl"
      toggle={() => {
        toggleModal()
        reload && reload()
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Financing
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal()
            reload && reload()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Row>
          <Col>
            <Alert
              id="helpView"
              variant="light"
              className="always-enabled"
              style={{ marginBottom: "10px", paddingBottom: "0px" }}
            >
              <div>
                Use the interest and fee rates saved to calculate the fees or
                interest from costs entered in the forecast.
                <ol>
                  <li>
                    Select the fee that you want to calculate from the dropdown.
                  </li>
                  <li>
                    Indicate which expenses contribute to those fees by putting
                    a percentage of each years cost. If they all apply, enter
                    100%. If they apply for all years, enter it in the “All”
                    Column.
                  </li>
                  <li>
                    Click “View “to see how much the fee comes to in each year.
                  </li>
                  <li>
                    Select the cost pool you want to copy the total to click
                    “Copy”. This will update the forecast cost pool with the
                    calculated fees/interest.”
                  </li>
                </ol>
              </div>
            </Alert>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <div className="d-flex-row ai-end gap-3">
              <div>
                <Label className="form-label">
                  Select Interest Rate or Fee
                </Label>
                <select
                  className="form-control form-select select2 mb-xxl-0"
                  value={selectedRateId}
                  onChange={e => {
                    setSelectedRateId(e.target.value)
                  }}
                  style={{ width: "300px" }}
                >
                  <option value="-1">Select rate...</option>
                  {interestAndFeeRates.map((s, i) => (
                    <option key={i} value={s.bcRateID}>
                      {s.bcRateName}
                    </option>
                  ))}
                </select>
              </div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  if (isEditMode) {
                    saveData()
                  }
                  setIsEditMode(!isEditMode)
                  setSummaryTable([])
                }}
              >
                {isEditMode ? "View" : "Edit"}
              </button>
            </div>
          </Col>
        </Row>
        {isLoading && (
          <Loader
            type="line-scale-pulse-out"
            color={colors.primary}
            style={{ textAlign: "center" }}
          />
        )}

        {!isLoading && (
          <>
            {isEditMode && (
              <Row className="mb-3">
                <Col>
                  <h3>
                    <b>Costs</b>
                  </h3>
                  {costPoolYears.length > 0 && (
                    <table
                      className="table table-bordered lower-padding-table"
                      style={{ backgroundColor: "white", fontSize: "12px" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "18%" }}></th>
                          <th
                            style={{ width: `${35 / costPoolYears.length}%` }}
                          >
                            All
                          </th>
                          {costPoolYears.map((y, idx) => (
                            <th
                              key={idx}
                              style={{
                                width: `${35 / costPoolYears.length}%`,
                              }}
                            >
                              FY {y.yearID}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {getTableRowsToRender(costTable1, "costTable1")}
                        {getTableRowsToRender(costTable2, "costTable2")}
                        {getTableRowsToRender(costTable3, "costTable3")}
                      </tbody>
                    </table>
                  )}
                </Col>
              </Row>
            )}
            {!isEditMode &&
              summaryTable.length > 0 &&
              costPoolYears.length > 0 && (
                <Row>
                  <Col>
                    <h3 className="mb-3">
                      <b>Summary</b>
                    </h3>
                    {summaryTable.length > 0 && (
                      <table
                        className="table table-bordered lower-padding-table"
                        style={{ backgroundColor: "white", fontSize: "12px" }}
                      >
                        <thead>
                          <tr>
                            {Object.keys(summaryTable[0])
                              .filter(x => x.startsWith("c-"))
                              .map((k, idx) => (
                                <th
                                  style={{
                                    textAlign:
                                      parseInt(k.replace("c-", "")) !== NaN
                                        ? "center"
                                        : "start",
                                  }}
                                  key={idx}
                                >
                                  {k.replace("c-", "") == "Cost Pool"
                                    ? ""
                                    : k.replace("c-", "")}
                                </th>
                              ))}
                          </tr>
                        </thead>
                        <tbody>
                          {summaryTable.map((f, i) => {
                            return (
                              <tr
                                key={i}
                                style={{
                                  backgroundColor: f.backColor,
                                }}
                              >
                                {Object.keys(f)
                                  .filter(x => x.startsWith("c-"))
                                  .map((k, idx2) => (
                                    <td
                                      key={idx2}
                                      className={
                                        !isNaN(f[k]) ? "align-end" : ""
                                      }
                                      style={{
                                        fontWeight:
                                          idx2 == 0 || f.bold == "1"
                                            ? 600
                                            : 100,
                                      }}
                                    >
                                      {k == "c-Total" && f.format == "%"
                                        ? ""
                                        : idx2 == 0
                                        ? f[k]
                                        : f.format == "$"
                                        ? currencyFormatter.format(f[k])
                                        : f.format == "%"
                                        ? `${f[k]}%`
                                        : f[k]}
                                    </td>
                                  ))}
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    )}
                    <div className="d-flex-row ai-end justify-content-end gap-3">
                      <div>
                        <Label className="form-label">Copy Total Into</Label>
                        <select
                          className="form-control form-select select2 mb-xxl-0"
                          value={selectedCostPoolId}
                          onChange={e => {
                            setSelectedCostPoolId(e.target.value)
                          }}
                          style={{ width: "200px" }}
                        >
                          <option value="-1">No selection...</option>
                          {allCosts.map((s, idx) => (
                            <option key={idx} value={s.costPoolID}>
                              {s.costPoolType} - {s.costPoolName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={selectedCostPoolId == -1}
                        onClick={copyToCostPool}
                      >
                        Copy
                      </button>
                    </div>
                  </Col>
                </Row>
              )}
          </>
        )}
      </div>
      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={() => {
            toggleModal()
            reload && reload()
          }}
        >
          Cancel
        </button>
        {/* {isEditMode && (
          <button
            type="button"
            className="btn btn-primary save-user"
            onClick={saveData}
            disabled={isSaving}
          >
            Save
          </button>
        )} */}
      </div>
    </Modal>
  )
}

export default FinancingModal
